module.exports = __webpack_public_path__ + "static/media/p404.9db9d742.png";